import React from 'react'
import GenericMenu from './source/GenericMenuProject';
import { SLUGS } from 'src/enum/permissions.enum';

const MULTI_PROJECT_MENU = {
  documents: [
    { check: SLUGS.PROJECT.ROOT.LIST, to: '/multi/material', primary: 'Список' },
    { check: SLUGS.PROJECT.ESTIMATE_LOAD.EXCEL_FILE, to: '/multi/material/load', primary: 'Загрузить' },
  ],
  workDoc: [
    { check: SLUGS.WORK_DOC.READ, to: '/workdoc', primary: 'Список' },
    { check: SLUGS.OCR, to: '/vlm', primary: 'Распознать' },
  ],
}
const MULTI_PROJECT_SECTION = {
  documents: 'Материалы',
  workDoc: 'Рабочая документация',
}

export default function MultiProjectMenu(props) {
  return (
    <GenericMenu
      menuConfig={MULTI_PROJECT_MENU}
      sectionsMap={MULTI_PROJECT_SECTION}
      propsRouter={props}
    />
  );
}